import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18nBackendOptions from "./i18n_backend_options"
// import enTranslation from './locales/en/translation';
// import viTranslation from './locales/vi/translation';
import i18nDetectorOptions from './i18n_detector_options';

import enTranslation from './locales/en/translation.json'
import viTranslation from './locales/vi/translation.json'
import simaTranslation from './locales/sima/translation.json'
import frenchTranslation from './locales/fr/translation.json'


// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)

    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init(

        {
            // lng: "en",
            fallbackLng: ['en', 'vi','fr'],
            supportedLngs: ['en', 'vi','fr', 'sima'],
            debug: true,
            nonExplicitSupportedLngs: false,
            // backend: i18nBackendOptions,
            detector: i18nDetectorOptions,
            // saveMissing: true,
            // keySeparator: false,
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            resources: {
                en: { translation: enTranslation },
                vi: { translation: viTranslation },
                sima: { translation: simaTranslation },
                fr: { translation: frenchTranslation }
            },
            react: {
                wait: true,
            }
        }
    );


export default i18n;